import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Preloader from './components/Preloader';
import Login from './pages/login/Login';
import ResetPassword from './pages/login/ResetPassword';
import Dashboard from './pages/dashboard/Dashboard';
import SuperAdminDashboard from './pages/dashboard/SuperAdminDashboard';
import Layout from './components/Layout';
import TecogisAdmin from './pages/tecogis_admin/TecogisAdmin';
import EventMaster from './pages/event_master/EventMaster';
import EventUser from './pages/event_user/EventUser';
import OccasionMaster from './pages/occasion_master/OccasionMaster';
import OccasionPrintLabel from './pages/occasion_master/OccasionPrintLabel';
import Lookup from './pages/lookup/Lookup';
import GuestMaster from './pages/guest_master/GuestMaster';
import GuestAttendee from './pages/guest_master/GuestAttendee';
import GuestAllocation from './pages/guest_master/GuestAllocation';
import SendInvites from './pages/send_invites/SendInvites';
import GuestRsvp from './pages/send_invites/GuestRsvp';
import RSVP from './pages/rsvp_response/RSVP';
import SeatAllocationBoard from './pages/seat_allocation/SeatAllocationBoard';
import SeatLayoutStudio from './pages/seat_allocation/SeatLayoutStudio';
import Accomodation from './pages/accomodation/Accomodation';
import HotelMaster from './pages/hotel_master/HotelMaster';
import StayReports from './pages/reports/StayReports';
import GuestInviteReport from './pages/reports/GuestInviteReport';
import TravelReport from './pages/reports/TravelReport';
import SeatReport from './pages/reports/SeatReport';
import GuestItinerary from './pages/guest_itinerary/GuestItinerary';
import RoleAccess from './pages/role_access/RoleAccess';
import AuditLog from './pages/audit_log/AuditLog';
import AppToaster from './components/AppToaster';

function App() {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading (e.g., fetching initial data or assets)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // Customize duration if needed

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Preloader />;
  }

  return (
    <Router>
      <AppToaster />
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/guest-rsvp" element={<GuestRsvp />} />
        <Route path="/guest-itinerary" element={<GuestItinerary />} />
        
        {/* Protected Routes */}
        <Route path="/" element={<Layout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="super-admin-dashboard" element={<SuperAdminDashboard />} />
          <Route path="tecogis-admin" element={<TecogisAdmin />} />
          <Route path="event-master" element={<EventMaster />} />
          <Route path="role-access" element={<RoleAccess />} />
          <Route path="audit-log" element={<AuditLog />} />
          <Route path="event-user" element={<EventUser />} />
          <Route path="occasion-master" element={<OccasionMaster />} />
          <Route path="occasion-print-label" element={<OccasionPrintLabel />} />
          <Route path="lookup" element={<Lookup />} />
          <Route path="guest-master" element={<GuestMaster />} />
          <Route path="guest-attendee" element={<GuestAttendee />} />
          <Route path="allocate-guest" element={<GuestAllocation />} />
          <Route path="send-invites" element={<SendInvites />} />
          <Route path="track-invites" element={<RSVP />} />
          <Route path="seat-allocation/board" element={<SeatAllocationBoard />} />
          <Route path="seat-allocation/layouts" element={<SeatLayoutStudio />} />
          <Route path="guest-accomodation" element={<Accomodation />} />
          <Route path="travel-and-stay" element={<Accomodation />} />
          <Route path="hotel-master" element={<HotelMaster />} />
          <Route path="stay-reports" element={<StayReports />} />
          <Route path="reports/guest-invites" element={<GuestInviteReport />} />
          <Route path="reports/travel" element={<TravelReport />} />
          <Route path="reports/seat-allocation" element={<SeatReport />} />
          <Route path="travel" element={<Accomodation />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
